/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePhone
 */
export interface UpdatePhone {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhone
     */
    firebaseIdToken: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePhone
     */
    userId: number;
}

/**
 * Check if a given object implements the UpdatePhone interface.
 */
export function instanceOfUpdatePhone(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firebaseIdToken" in value;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function UpdatePhoneFromJSON(json: any): UpdatePhone {
    return UpdatePhoneFromJSONTyped(json, false);
}

export function UpdatePhoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firebaseIdToken': json['firebaseIdToken'],
        'userId': json['userId'],
    };
}

export function UpdatePhoneToJSON(value?: UpdatePhone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firebaseIdToken': value.firebaseIdToken,
        'userId': value.userId,
    };
}

